import type { ElementType, ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { PAGE_TOOLBAR, toggleButtonClass } from './pageToolbarStyles'

export interface ToolbarToggleOption<T extends string = string> {
  id: T
  icon: ElementType
  label: string
}

interface ToolbarToggleGroupProps<T extends string> {
  value: T
  onChange: (value: T) => void
  options: ToolbarToggleOption<T>[]
  ariaLabel?: string
  className?: string
}

/** Grupo segmentado 32×32 — ex.: Kanban / Lista */
export function ToolbarToggleGroup<T extends string>({
  value,
  onChange,
  options,
  ariaLabel = 'Modo de visualização',
  className,
}: ToolbarToggleGroupProps<T>) {
  return (
    <div
      className={cn(PAGE_TOOLBAR.toggleGroup, className)}
      role='group'
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const Icon = opt.icon
        const isActive = value === opt.id
        return (
          <button
            key={opt.id}
            type='button'
            onClick={() => onChange(opt.id)}
            className={toggleButtonClass(isActive)}
            title={opt.label}
            aria-label={opt.label}
            aria-pressed={isActive}
          >
            <Icon size={14} />
          </button>
        )
      })}
    </div>
  )
}

interface ToolbarControlsGroupProps {
  children: ReactNode
  className?: string
}

export function ToolbarControlsGroup({ children, className }: ToolbarControlsGroupProps) {
  return <div className={cn(PAGE_TOOLBAR.controlsGroup, className)}>{children}</div>
}
